/*
@license
  Expanse by Archetype Themes (https://archetypethemes.co)
  Access unminified JS in assets/theme.js

  Use this event listener to run your own JS outside of this file.
  Documentation - https://archetypethemes.co/blogs/expanse/javascript-events-for-developers

  document.addEventListener('page:loaded', function() {
    // Page has loaded and theme assets are ready
  });
*/

if (console && console.log) {
  console.log(
    "Expanse theme (" +
      theme.settings.themeVersion +
      ") by ARCHΞTYPE | Learn more at https://archetypethemes.co"
  );
}

(function () {
  "use strict";

  if (
    window.Shopify &&
    window.Shopify.theme &&
    navigator &&
    navigator.sendBeacon &&
    window.Shopify.designMode
  ) {
    navigator.sendBeacon(
      "https://api.archetypethemes.co/api/beacon",
      new URLSearchParams({
        shop: window.Shopify.shop,
        themeName:
          window.theme &&
          window.theme.settings &&
          `${window.theme.settings.themeName} v${window.theme.settings.themeVersion}`,
        role: window.Shopify.theme.role,
        route: window.location.pathname,
        themeId: window.Shopify.theme.id,
        themeStoreId: window.Shopify.theme.theme_store_id || 0,
        isThemeEditor: !!window.Shopify.designMode,
      })
    );
  }

  /*============================================================================
    Things that don't require DOM to be ready
  ==============================================================================*/

  /*============================================================================
    Things that require DOM to be ready
  ==============================================================================*/
  function DOMready(callback) {
    if (document.readyState != "loading") callback();
    else document.addEventListener("DOMContentLoaded", callback);
  }

  DOMready(function () {
    document.dispatchEvent(new CustomEvent("page:loaded"));
  });
})();


$(document).ready(function(){
        $('body').on('click','.contact-popup-btn',function(e){
          e.preventDefault();
          console.log('click');
          var p = $(this).data('title');
          $('.product_name').val(p);
          $('body').addClass('openpopup');
          $('.popup_outwrapper').css('display','block');
        });
        $('body').on('click','.close-popup',function(){
          $('body').removeClass('openpopup');
          $('.popup_outwrapper').css('display','none');
          $('.err-msg').remove();
        });
        $('#ContactForm').on('submit',function(){
          var x = true;
          $('.err-msg').remove();
          var fn = $(this).find('#name');
          var em = $(this).find('#email');
          var pn = $(this).find('#phone');
          var mg = $(this).find('#order');
          var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
          var phoneno = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
          if(fn.val().trim() == ''){
            $('.popup_innerwrapper').append('<p class="err-msg">Please enter name</p>');
            x = false;
          }
          else if(em.val().trim() == '' || !regex.test(em.val())) {
            $('.popup_innerwrapper').append('<p class="err-msg">Please enter valid e-mail</p>');
            x = false;
          } 
          else if(pn.val().trim() == '' || !phoneno.test(pn.val())) {
            $('.popup_innerwrapper').append('<p class="err-msg">Please enter valid phone number</p>');
            x = false;
          }
          else if(mg.val().trim() == ''){
            $('.popup_innerwrapper').append('<p class="err-msg">Please select quantity</p>');
            x = false;
          }
          else {
            $('.err-msg').remove();
          }
          if(x==false) {
            return false;
          }
        });
  $('body').on('click','.custom_upsell_button',function(e){
    e.preventDefault();
    var moneyformat = $('body').attr('data-money-format');
    var c = $(this);
    var data_id = $(this).data('id');
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: { id:data_id,quantity:1},
      dataType: "json",
      error: function(d, p, h) {
        var f = $.parseJSON(d.responseText);
        c.after('<p class="error">' + f.description + "</p>").find(".error").fadeIn().delay(4e3).fadeOut();
      }
    }).done(function(d) {
      $.get("/cart?view=new_cart", function(data) {
        console.log(data);
        var new_data_arr = data.split("[split11]");
        $('[data-products]').html(new_data_arr[0]);
        $('.cart__item-sub').html(new_data_arr[1]);
      });
      $.getJSON("/cart.js", function(data_sub_total) {
        $('.cart-link__bubble').addClass('cart-link__bubble--visible');
        $('.cart-link__bubble-num').html(data_sub_total.item_count);
      });
    });
  });
  $('body').on('click','.site-header__drawer .cart__remove a',function(e){
    e.preventDefault();
    var moneyformat = $('body').attr('data-money-format');
    var c = $(this);
    var data_id = $(this).data('remove_id');
    console.log(data_id);
    $.ajax({
      type: "POST",
      url: "/cart/change.js",
      data: { id:data_id,quantity:0},
      dataType: "json",
      error: function(d, p, h) {
        var f = $.parseJSON(d.responseText);
        c.after('<p class="error">' + f.description + "</p>").find(".error").fadeIn().delay(4e3).fadeOut();
      }
    }).done(function(d) {
      $.get("/cart?view=new_cart", function(data) {
        console.log(data)
        $('[data-products]').html(data);
      });
      $.getJSON("/cart.js", function(data_sub_total) {
        if(data_sub_total.item_count == 0){
		  $('.site-header__drawer .cart__footer').hide();
          $('.cart-link__bubble').removeClass('cart-link__bubble--visible');
        }
        else{
          $('[data-subtotal]').html(theme.Currency.formatMoney(data_sub_total.total_price,moneyformat));
        }
      });
    });
  });
});

